/*
 * Toolbar state art. BeMail's is R5's BMAP resources, 28x20 with all four
 * states; NetPositive's is dano's res/*.gif, 36x20 with no rollover. Stop and
 * Download are throbbers, animated only while loading: `_still.gif` is frame 0,
 * which GIFButton draws the rest of the time.
 */

import type { BeToolbarArt } from "@beos-css/react/index.ts";

const bemail = (name: string): BeToolbarArt => ({
	enabled: new URL(`./bemail/${name}-enabled.png`, import.meta.url).href,
	rollover: new URL(`./bemail/${name}-rollover.png`, import.meta.url).href,
	pressed: new URL(`./bemail/${name}-pressed.png`, import.meta.url).href,
	disabled: new URL(`./bemail/${name}-disabled.png`, import.meta.url).href,
	width: 28,
	height: 20,
});

const netpositive = (name: string, up = "up"): BeToolbarArt => ({
	enabled: new URL(`./netpositive/${name}_${up}.gif`, import.meta.url).href,
	pressed: new URL(`./netpositive/${name}_down.gif`, import.meta.url).href,
	disabled: new URL(`./netpositive/${name}_disabled.gif`, import.meta.url).href,
	width: 36,
	height: 20,
});

export const bemailIcons = {
	new: bemail("new"),
	send: bemail("send"),
	draft: bemail("draft"),
	signature: bemail("sig"),
	print: bemail("print"),
	trash: bemail("trash"),
	reply: bemail("reply"),
	forward: bemail("forward"),
	next: bemail("next"),
	previous: bemail("previous"),
	inbox: bemail("mailbox"),
	mail: bemail("mailfolder"),
};

export const netpositiveIcons = {
	back: netpositive("back"),
	forward: netpositive("forward"),
	stop: netpositive("stop", "still"),
	stopAnimated: netpositive("stop"),
	reload: netpositive("reload"),
	search: netpositive("search"),
	home: netpositive("home"),
	downloads: netpositive("dl_button", "still"),
	downloadsAnimated: netpositive("dl_button"),
};
